import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IReviewList, IReviewNew } from "./IReview";

export const reviewApi = createApi({
  reducerPath: "review",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.REVIEW,
  }),
  tagTypes: ["review", "re1"],
  endpoints: (builder) => ({
    getAllReviews: builder.query<IReviewList[], number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["review"],
    }),
    addReview: builder.mutation<any, IReviewNew>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["review"],
    }),
    getReview: builder.query<IReviewList, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["re1"],
    }),
    editReview: builder.mutation<
      IReviewNew & { review_id: number },
      IReviewNew & { review_id: number }
    >({
      query({ review_id, ...body }) {
        return {
          url: `/${review_id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["review", "re1"],
    }),
    deleteReview: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["review"],
    }),
  }),
});

export const {
  useAddReviewMutation,
  useDeleteReviewMutation,
  useEditReviewMutation,
  useGetAllReviewsQuery,
  useGetReviewQuery,
} = reviewApi;
